/** 스크롤 복원 재시도 타이밍 (ms) */
export const SCROLL_RETRY_DELAYS_MS = [200, 600, 1200, 2500, 4000] as const;

/** 스크롤 복원 완료 타임아웃 (ms) */
export const SCROLL_RESTORE_TIMEOUT_MS = 5000;

/** 오버레이 최소 표시 시간 (ms) */
export const OVERLAY_MIN_TIME_MS = 400;

/**
 * 스크롤 복원 대상 요소를 찾습니다.
 * 우선순위: (episodeId + cursor + charOffset) > (episodeId + cursor) > episodeId
 */
export const getScrollTargetElement = (
  container: HTMLElement,
  episodeId: string,
  cursor?: string | null,
  charOffset?: string | null
): { element: HTMLElement; foundPrecise: boolean } | null => {
  let target: HTMLElement | null = null;
  let foundPrecise = false;

  if (charOffset != null && charOffset !== '' && cursor != null && cursor !== '') {
    target = container.querySelector<HTMLElement>(
      `[data-scene-episode-id="${episodeId}"][data-paragraph-index="${cursor}"][data-char-offset="${charOffset}"]`
    );
    foundPrecise = !!target;
  }
  if (!target && cursor != null && cursor !== '') {
    target = container.querySelector<HTMLElement>(
      `[data-scene-episode-id="${episodeId}"][data-paragraph-index="${cursor}"]`
    );
    foundPrecise = !!target;
  }
  if (!target) {
    target = container.querySelector<HTMLElement>(`[data-scene-episode-id="${episodeId}"]`);
  }

  return target ? { element: target, foundPrecise } : null;
};
